import { Cache } from "memory-cache";
import { ImplantEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedImplantsEntity(character_id: number): Promise<ImplantEntity | null> {
  let entity: any = await cache.get(character_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedImplantsEntity(implants: ImplantEntity) {
  cache.put(implants.props._character_id, implants, 60 * 60 * 1000 /* 1 hour */);
}
